<feed-image-modal [imageId]="data.imageId" [imageOptions]="data.imageOptions">
    <ng-template let-image="image">
        <image-metadata class="padleftright24 mbot16 db" [image]="image"></image-metadata>
        <deephub-object-detection-report-pair-list *ngIf="pairList$ | async as pairList" [pairList]="pairList"></deephub-object-detection-report-pair-list>
    </ng-template>
</feed-image-modal>